'use strict';

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _assets = require('../../utils/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACEBOOK = 'FACEBOOK';
var INSTAGRAM = 'INSTAGRAM';
var YOUTUBE = 'YOUTUBE';
var TWITTER = 'TWITTER';
var TELEGRAM = 'TELEGRAM';
var STORIES = 'stories';
var STORY = 'STORY';

var getAssetCount = function getAssetCount(posts) {
  return posts.length;
};

var isManualDataOnlyAsset = function isManualDataOnlyAsset(post) {
  return _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'SNAPCHAT') || _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'VK') || _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'BLOG');
};

var getLatestSupportingData = function getLatestSupportingData(supportingData) {
  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  return latestSupportingData;
};

var getInfluencerCount = function getInfluencerCount(posts) {
  var prefiltered = _lodash2.default.map(posts, function (p) {
    if (p.discussionId) return { discussionId: p.discussionId };

    if (_lodash2.default.get(p, 'platform') === 'TIKTOK') {
      return { discussionId: _lodash2.default.get(_lodash2.default.get(p, 'discussion'), 'id') };
    }
    if (_lodash2.default.get(p, 'type') === 'stories') {
      return { discussionId: _lodash2.default.get(p, 'relationships.discussion.data.id') };
    }
    // if (_.get(p, 'trackedAsset.platform') === 'INSTAGRAM' && _.has(p, 'instagramHandle')) {
    //   return { discussionName: _.get(p, 'instagramHandle') };
    // }
    return { discussionId: _lodash2.default.get(p, 'trackedAsset.discussionId', null) };
  });
  var filtered = _lodash2.default.filter(prefiltered, 'discussionId'); // get rid of posts without discussion
  var discussions = _lodash2.default.uniqBy(filtered, 'discussionId');

  return discussions.length || 1; // there must be 1 influencer?
};

var getTotalImpressions = function getTotalImpressions(posts, usesBoostedData) {
  return _lodash2.default.sumBy(posts, function (post) {
    var totalImpressions = void 0;

    if (_lodash2.default.get(post, 'platform') === 'TIKTOK') {
      // REMOVED 15 JUNE 2024 - requested impressions should not include TIKTOK Views
      // APRIL 21st 2026 - adding back reach and impressions for TIKTOK - LAB
      var initialData = post.initialData,
          tiktokData = post.tiktokData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;

      return _lodash2.default.get(latestTiktokData, 'playCount', 0) * 1.08;
    }

    if (post.type === STORIES) {
      var storyData = post.attributes.storyData;
      var data = post.relationships.supportingData.data;


      var latestSupportingData = _lodash2.default.last(data) || {};

      var latestData = _lodash2.default.get(latestSupportingData, 'attributes.impressions') ? _lodash2.default.get(latestSupportingData, 'attributes') : _lodash2.default.last(storyData);

      var nonboostedReach = _lodash2.default.get(latestData, 'impressions', 0);

      var boostedReach = _lodash2.default.get(post, 'attributes.finalImps');
      totalImpressions = usesBoostedData && boostedReach > 0 ? boostedReach : nonboostedReach;
    } else {
      if (usesBoostedData && _lodash2.default.has(post, 'finalImps')) {
        return _lodash2.default.get(post, 'finalImps');
      }
      var hasSupportingData = false;

      var insights = _lodash2.default.get(post, 'latestStatistic.insights');
      var hasInsightsError = insights && insights.error;

      if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK && insights) {
        totalImpressions = insights.totalVideoImpressions || insights.postImpressions || 0;
      }

      var fullSupportingData = _lodash2.default.get(post, 'supportingData', _lodash2.default.get(post, 'trackedAsset.supportingData', []));
      var _latestSupportingData = getLatestSupportingData(fullSupportingData);

      if (_latestSupportingData && _latestSupportingData.impressions) {
        hasSupportingData = true;
        totalImpressions = _latestSupportingData.impressions;
      }

      if (!hasSupportingData && _lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && insights && !hasInsightsError) {
        totalImpressions = insights.impressions || 0;
      }
    }
    return totalImpressions;
  });
};

var getTotalReach = function getTotalReach(posts, usesBoostedData) {
  return _lodash2.default.sumBy(posts, function (post) {
    var totalReach = void 0;

    if (_lodash2.default.get(post, 'platform') === 'TIKTOK') {
      // APRIL 21st 2026 - adding back reach and impressions for TIKTOK - LAB
      var initialData = post.initialData,
          tiktokData = post.tiktokData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;

      return _lodash2.default.get(latestTiktokData, 'playCount', 0) * 0.92;
    }

    if (_lodash2.default.get(post, 'platform', '') === TELEGRAM) {
      var telegramData = _lodash2.default.last(_lodash2.default.get(post, 'telegramData'));
      return _lodash2.default.get(telegramData, 'views', 0);
    }

    if (post.type === STORIES) {
      var storyData = post.attributes.storyData;
      var data = post.relationships.supportingData.data;


      var latestSupportingData = _lodash2.default.last(data) || {};

      var latestData = _lodash2.default.get(latestSupportingData, 'attributes.reach') ? _lodash2.default.get(latestSupportingData, 'attributes') : _lodash2.default.last(storyData);

      var nonboostedReach = _lodash2.default.get(latestData, 'reach', 0);

      var boostedReach = _lodash2.default.get(post, 'attributes.finalReach');
      totalReach = usesBoostedData && boostedReach > 0 ? boostedReach : nonboostedReach;
    } else {
      if (usesBoostedData && _lodash2.default.has(post, 'finalReach')) {
        return _lodash2.default.get(post, 'finalReach');
      }
      var hasSupportingData = false;

      var insights = _lodash2.default.get(post, 'latestStatistic.insights');
      var hasInsightsError = insights && insights.error;

      if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK && insights) {
        totalReach = insights.totalVideoImpressionsUnique || insights.postImpressionsUnique || 0;
      }

      var fullSupportingData = _lodash2.default.get(post, 'supportingData', _lodash2.default.get(post, 'trackedAsset.supportingData', []));
      var _latestSupportingData2 = getLatestSupportingData(fullSupportingData);

      if (_latestSupportingData2 && _latestSupportingData2.reach) {
        hasSupportingData = true;
        totalReach = _latestSupportingData2.reach;
      }

      if (!hasSupportingData && _lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && insights && !hasInsightsError) {
        totalReach = insights.reach || 0;
      }
    }
    return totalReach;
  });
};

var getTotalViews = function getTotalViews(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    var isStory = _lodash2.default.eq(_lodash2.default.get(post, 'type'), STORIES);
    var isVideo = _lodash2.default.eq(_lodash2.default.get(post, 'attributes.assetType'), 'VIDEO');
    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
    var linkedAds = _lodash2.default.get(post, 'attributes.linkedAds', []);
    var hasLinkedAds = !_lodash2.default.isEmpty(linkedAds);
    var isManual = isManualDataOnlyAsset(post);

    if (isManual) {
      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'views', 0);
    }

    if (isTiktok) {
      var tiktokData = post.tiktokData,
          initialData = post.initialData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'playCount', 0));
      return num;
    }

    var data = _lodash2.default.get(post, 'relationships.supportingData.data');

    var latestSupportingData = _lodash2.default.last(data) || {};

    if (!hasLinkedAds) {
      if (latestSupportingData && _lodash2.default.get(latestSupportingData, 'attributes.views')) {
        return _lodash2.default.get(latestSupportingData, 'attributes.views');
      }
      if (latestSupportingData && _lodash2.default.get(latestSupportingData, 'attributes.impressions')) {
        return _lodash2.default.get(latestSupportingData, 'attributes.impressions');
      }
    }

    if (isStory && isVideo) {
      var storyData = _lodash2.default.get(post, 'attributes.storyData', []);
      var latestData = _lodash2.default.last(storyData);

      var finalViews = _lodash2.default.get(post, 'attributes.finalViews');
      if (finalViews) return finalViews;

      var _num = _lodash2.default.toNumber(_lodash2.default.get(latestData, 'impressions', 0));
      return _num;
    }

    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.viewCount || 0;
    }

    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && post.trackedAsset.assetType === STORY) {
      var supportingData = post.trackedAsset.supportingData;

      var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
      var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
        return o.createdDate;
      }));
      var _latestSupportingData3 = ordered[0];

      return post.latestStatistic.openCount || _latestSupportingData3 && _latestSupportingData3.views || _latestSupportingData3 && _latestSupportingData3.impressions || 0;
    }

    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM || _lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK) {
      return post.latestStatistic ? post.latestStatistic.playCount || post.latestStatistic.viewCount || 0 : 0;
    }
    return 0;
  });
};

var getTotalClicks = function getTotalClicks(ads) {
  return _lodash2.default.sumBy(ads, function (ad) {
    return ad.insights ? Number(ad.insights.clicks) : 0;
  });
};

var getTotalLikes = function getTotalLikes(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    var isManual = isManualDataOnlyAsset(post);
    if (isManual) {
      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'likes', 0);
    }
    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
    if (isTiktok) {
      var tiktokData = post.tiktokData,
          initialData = post.initialData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'diggCount', 0));
      return num;
    }
    if (post.type === STORIES) return 0;
    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.likeCount || 0;
    }
    if (_lodash2.default.get(post, 'trackedAsset.platform') === TWITTER) {
      return post.latestStatistic.likeCount || 0;
    }
    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM || _lodash2.default.get(post, 'trackedAsset.platform ') === FACEBOOK) {
      return post.latestStatistic ? post.latestStatistic.likeCount || 0 : 0;
    }
    return 0;
  });
};

var getTotalComments = function getTotalComments(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    var isManual = isManualDataOnlyAsset(post);
    if (isManual) {
      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'comments', 0);
    }
    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
    if (isTiktok) {
      var tiktokData = post.tiktokData,
          initialData = post.initialData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'commentCount', 0));
      return num;
    }
    if (post.type === STORIES) return 0;
    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.commentCount || 0;
    }
    if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK) {
      return post.latestStatistic.commentCount || 0;
    }
    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM) {
      return post.latestStatistic.commentCount || 0;
    }
    return 0;
  });
};

var getTotalShares = function getTotalShares(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    var isManual = isManualDataOnlyAsset(post);
    if (isManual) {
      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'shares', 0);
    }
    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
    if (isTiktok) {
      var tiktokData = post.tiktokData,
          initialData = post.initialData;

      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'shareCount', 0));
      return num;
    }
    if (post.type === STORIES) return 0;
    var YT_SHARE_INDEX = 7;
    var platform = _lodash2.default.get(post, 'trackedAsset.platform');

    if (platform === FACEBOOK) {
      return post.latestStatistic.shareCount || 0;
    }
    if (platform === TWITTER) {
      return post.latestStatistic.retweetCount || 0;
    }
    var insights = _lodash2.default.get(post, 'latestStatistic.insights');
    if (platform === YOUTUBE && insights) {
      var shareCount = _lodash2.default.sumBy(insights.viewingByCountry, function (o) {
        return o[YT_SHARE_INDEX];
      });
      return shareCount;
    }
    return 0;
  });
};

module.exports = {
  getTotalReach: getTotalReach,
  getTotalImpressions: getTotalImpressions,
  getInfluencerCount: getInfluencerCount,
  getAssetCount: getAssetCount,
  getTotalViews: getTotalViews,
  getTotalComments: getTotalComments,
  getTotalLikes: getTotalLikes,
  getTotalShares: getTotalShares,
  getTotalClicks: getTotalClicks
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report/utils.js
 ** module id = 2612
 ** module chunks = 0
 **/